export default __webpack_public_path__ + "static/media/InjectionMoldingImg.e288120e.jpg";